// extracted by mini-css-extract-plugin
export default {"wrap":"List_wrap__8MLzo","subtitle":"List_subtitle__wSexg","desc":"List_desc__Kz1Xf"};